var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradientArc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 10,
    viewBox: "0 0 274 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7800_845)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7800_845)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.35 8.05003C166.243 2.31162 49.189 6.91915 3.70057 9.93972C2.32357 10.0312 1.12538 9.11882 1.02434 7.90197C0.923295 6.68511 1.95766 5.62453 3.33467 5.53309C48.9581 2.50355 166.258 -2.11573 270.67 3.63956C272.049 3.71549 273.094 4.76438 273.006 5.98231C272.917 7.20022 271.729 8.12598 270.35 8.05003Z",
    fill: "url(#paint0_linear_7800_845)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7800_845",
    x1: 25.986,
    y1: 8.76207,
    x2: 210.015,
    y2: -91.3561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D1DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223953,
    stopColor: "#6147FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46354,
    stopColor: "#D451FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.750004,
    stopColor: "#EC458D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA8B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7800_845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 8,
    fill: "white",
    transform: "translate(0.976562 1.96387) rotate(-0.405928)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7800_845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 8,
    fill: "white",
    transform: "translate(0.976562 1.96387) rotate(-0.405928)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientArc);
export default __webpack_public_path__ + "static/media/gradient_arc.6b8462b15dc1458d0fa3b42f4b1ab408.svg";
export { ForwardRef as ReactComponent };